import { Component, Input } from '@angular/core'
import { Company } from '../../../common/interfaces/company.interface'
import { environment } from '../../../../environments/environment'
import { ResourceService } from '../../../common/services/resource.service'
import { Role } from '../../../common/enums/role.enum'

@Component({
  selector: 'app-company-table',
  templateUrl: './company-table.component.html',
  styleUrls: ['./company-table.component.scss'],
  providers: [ResourceService]
})
export class CompanyTableComponent {
  @Input() companies: Company[]

  Role = Role
  companyToDelete: Company
  storagePath: string = environment.storagePath

  constructor(private resourceService: ResourceService) {}

  toggleActive(company: Company) {
    this.resourceService
      .patch('companies', company.id, 'toggle-active', new FormData())
      .subscribe(() => {
        company.active = !company.active
      })
  }

  delete(company: Company): void {
    this.companyToDelete = company
  }

  onDeleteCanceled() {
    delete this.companyToDelete
  }
}
